import {createSelector, capitalize, mapValues, keyBy, invert, toNumber} from 'helpers';
import {module} from 'store/common';

export const index = createSelector(
  state => state.sortingInfo,
  state => keyBy(state, ({ name = '', modelId, type }) => {
    if (parseInt(modelId)) {
      return capitalize(type) + modelId
    }
    return name;
  })
);

export const sorting = createSelector(
  [ index, module ],
  ( index, module ) => {
    const { ids } = index[capitalize(module)] || {};
    return mapValues(invert(ids ? ids.split(',') : {}), toNumber);
  },
  { memoizeOptions: { maxSize: 50 } },
);
